import { useEffect, useState } from "react"
import FormComp from "../../../Componentes/FormComp"
import Overlay from "../../../Componentes/Overlay"
import Formulario from "../../../Componentes/Utils/Formulario"
import Modal from "../../../Componentes/Utils/Modal"
import useApi from "../../../hooks/useApi";

const ModalEditItens = ({ id_tipo, id_modelo, fetchSuccess, fecharModal, itemSelected }) => {
    const api = useApi();


    const [loading, setLoading] = useState(false);
    const [item, setItem] = useState("")

    useEffect(() => {
        if (itemSelected) {
            setItem(itemSelected.item)
        }
    }, [itemSelected])

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!item || item.trim() === "") return;

        setLoading(true);

        try {

            console.log( itemSelected )

            if (itemSelected) {
                await api.post(
                    "/Painel/API/Checklist/EditItem/",
                    { item, id: itemSelected.id },
                    { withCredentials: true }
                );
            } else {
                await api.post(
                    "/Painel/API/Checklist/SaveNewItem/",
                    { item, id_tipo, id_modelo },
                    { withCredentials: true }
                );
            }

            fetchSuccess?.();
            fecharModal();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Overlay state={true} >
                <Modal header close={fecharModal} >
                    <Formulario onSubmit={handleSubmit} >
                        <FormComp
                            title="ITEM"
                            type="text"
                            valor={item}
                            changeFunc={(e) => setItem(e.target.value.toUpperCase())}
                        />
                        <FormComp
                            type="submit"
                            valor={loading ? "SALVANDO..." : "SALVAR"}
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalEditItens;